<template>
  <nav class="nav">
    <ui-confirm ref="logout" :title="$t('header.logout-confirm.title')" :confirm-button-text="$t('header.logout-confirm.yes')"
                :deny-button-text="$t('header.logout-confirm.no')" @confirm="logoutConfirmed" :closeOnConfirm="true">
        {{$t('header.logout-confirm.text')}}
    </ui-confirm>
    <div class="row">
      <div class="small-4 column">
        <back-links></back-links>
      </div>
      <div class="small-4 column">
         <h1 class="app-title">{{ pageTitle }}</h1>
      </div>
      <div class="small-4 column">
        <ul class="nav-links clearfix">
          <li v-if="$store.state.user && $store.state.user.hasEshop">
            <a :href=ShopUrl title="EShop" class="cart-link ui-icon-button logout-link float-right ui-icon-button--type-normal ui-icon-button--color-default ui-icon-button--size-normal">
              <ui-icon color="default" type="normal" icon="shopping_cart"></ui-icon>
            </a>
          </li>
          <ui-icon-button class="logout-link float-right" color="default" type="normal" icon="lock_open" @click="showConfirm('basicConfirm')"></ui-icon-button>
          <router-link :to="{name: 'search'}" class="hide-for-large search-link float-right" tag="li"><ui-icon-button color="default" type="normal" icon="search"></ui-icon-button></router-link>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import BackLink from '../BackLink'

export default {
  name: 'app-nav',
  data () {
    return {
      ShopUrl: ''
    }
  },
  computed: {
    pageTitle () {
      return (this.$route.meta.title) ? this.$route.meta.title : this.$t('header.title')
    },
    userInfo () {
      return this.$store.dispatch('getUserInfo', window.localStorage.getItem('authToken'))
    }
  },
  mounted () {
    this.ShopUrl = process.env.B2B_URL + '/o/somfy/sso_login?redirect=ext_eshop'
  },
  methods: {
    logoutConfirmed () {
      this.$store.dispatch('logoutUser')
    },
    showConfirm () {
      this.$refs.logout.open()
    }
  },
  components: {
    'back-links': BackLink
  }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
  @import '~scss/variables';
  @import '~foundation';

  nav.nav {
    background-color: $somfy;
    height: 55px;
    overflow: hidden;

    h1.app-title {
      margin: 0;
      font-size: 16px;
      color: $body-light;
      text-align: center;
      line-height: 55px;

      /* Medium and up */
      @include breakpoint(medium) {
        // line-height: 55px;
        font-size: 20px;
        padding-top: 0;
      }
    }

    ul.nav-links {
      padding: 9px 0 0 0;
      margin: 0;
      text-align: right;
      list-style: none;
      &.left{
        text-align: left;
      }
      li.search-link {
        margin-right: 6px;
      }
    }

    .cart-link {
      margin-left: 10px;
      span {
        color: $somfy
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Nav.vue?44deb58e